var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16549 0.78125H15.9574C19.3373 0.78125 22.0774 3.52117 22.0774 6.90105V16.6927C22.0774 20.0725 19.3373 22.8125 15.9574 22.8125H6.16549C2.78553 22.8125 0.0455322 20.0725 0.0455322 16.6927V6.90105C0.0455322 3.52117 2.78553 0.78125 6.16549 0.78125ZM16.8809 7.20512C17.5569 7.20512 18.1049 6.65713 18.1049 5.98115C18.1049 5.30519 17.5569 4.7572 16.8809 4.7572C16.2048 4.7572 15.6568 5.30519 15.6568 5.98115C15.6568 6.65713 16.2048 7.20512 16.8809 7.20512ZM11.0628 6.28908C8.02076 6.28908 5.55475 8.75501 5.55475 11.7969C5.55475 14.8388 8.02076 17.3047 11.0628 17.3047C14.1046 17.3047 16.5707 14.8388 16.5707 11.7969C16.5739 10.3351 15.9947 8.9323 14.9611 7.89868C13.9273 6.86506 12.5245 6.28582 11.0628 6.28908ZM7.6966 11.795C7.6966 13.654 9.20359 15.1609 11.0626 15.1609C12.9215 15.1609 14.4285 13.654 14.4285 11.795C14.4285 9.93604 12.9215 8.42908 11.0626 8.42908C9.20359 8.42908 7.6966 9.93604 7.6966 11.795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaImage);
export default __webpack_public_path__ + "static/media/insta-image.fab389a8f64b43f702b8a23720369bbc.svg";
export { ForwardRef as ReactComponent };